/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />
//
import { computePosition, offset, shift, size } from '@floating-ui/dom'

export function polyfillPopoverPlacements() {
  const popovers = Array.from(
    document.querySelectorAll<HTMLElement>('[popover]'),
  )

  function getPlacement(target: HTMLElement): string {
    const classes = target.className

    const vertical = classes.includes('popover--vertical-top')
      ? 'top'
      : classes.includes('popover--vertical-bottom')
      ? 'bottom'
      : null

    const horizontal = classes.includes('popover--horizontal-left')
      ? 'start'
      : classes.includes('popover--horizontal-right')
      ? 'end'
      : null

    if (vertical && horizontal) {
      return `${vertical}-${horizontal}`
    }

    if (vertical) {
      return vertical + '-start'
    }

    if (horizontal) {
      return 'top' + horizontal
    }

    return 'bottom'
  }

  for (const popover of popovers) {
    if (popover.dataset.hydrated) continue
    popover.dataset.hydrated = 'true'
    popover.addEventListener('toggle', async (e: ToggleEvent) => {
      const target = e.target as HTMLElement
      const trigger = document.querySelector<HTMLElement>(
        `[popovertarget="${target.id}"]`,
      )

      if (e.newState !== 'open') {
        target.style.display = ''
        target.style.top = ''
        target.style.left = ''
        target.style.transform = ''

        return
      }

      if (!trigger) return

      const placement = getPlacement(target)

      const { x, y } = await computePosition(trigger, target, {
        strategy: 'fixed',
        // @ts-ignore: its ok, thx
        placement,
        middleware: [
          offset(10),
          shift(),
          size({
            apply({ rects, elements }) {
              Object.assign(elements.floating.style, {
                width: `${rects.reference.width}px`,
              })
            },
          }),
        ],
      })

      Object.assign(target.style, {
        display: 'initial',
        top: `${y}px`,
        left: `${x}px`,
        transform: placement.startsWith('top') ? 'translateY(-100%)' : '',
      })
    })
  }
}
